import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { baseURL } from "@/utility/api";
import ArticleShipHero from "@/components/ArticleComponents/ArticleShipHero";
import ArticleProcess from "@/components/ArticleComponents/ArticleProcess";
import ArticleCurriculum from "@/components/ArticleComponents/ArticleCurriculum";
import ArticleDifference from "@/components/ArticleComponents/ArticleDifference";
import ArticleInstructor from "@/components/ArticleComponents/ArticleInstructor";
import ArticleLearn from "@/components/ArticleComponents/ArticleLearn";
import ArticleWhyJoin from "@/components/ArticleComponents/ArticleWhyJoin";

const Articleship = () => {
  const [details, setDetails] = useState({
    price: "999",
    startDate: "2nd August 2025",
  });

  useEffect(() => {
    const fetchDetails = async () => {
      const response = await axios.post(`${baseURL}/cohort/get-details`, {
        id: 107,
      });
      setDetails(response.data);
    };
    fetchDetails();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white font-inter px-0 md:px-0">
      <ArticleShipHero details={details} />
      <ArticleInstructor />
      <ArticleCurriculum />
      <ArticleWhyJoin />
      <ArticleLearn />
      <ArticleProcess />
      <ArticleDifference />
    </div>
  );
};

export default Articleship;
